export default "__VITE_ASSET__hlRuN8fCwC$O1bOmja25ug__"